import { useNavigate } from 'react-router-dom'
import { ArrowLeft, FileQuestion } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { cn } from '@/lib/utils'
import { PAGE_H_CLASS } from '@/components/layout/pageHeight'
import { messages } from './messages'

export const EditorFetchFailed = () => {
  const navigate = useNavigate()
  const m = useMessages(messages)

  return (
    <div className={cn('flex flex-col', PAGE_H_CLASS)}>
      <div className="flex items-center px-6 h-14 border-b border-border">
        <Button variant="ghost" size="sm" onClick={() => navigate('/instructions')}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          {m.back}
        </Button>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center text-center px-6 gap-4">
        <FileQuestion className="h-16 w-16 text-muted-foreground/40" />
        <h2 className="text-2xl font-semibold">{m.cannotEdit}</h2>
        <p className="text-muted-foreground max-w-md">{m.cannotEditHint}</p>
      </div>
    </div>
  )
}
